import React from "react";
import propTypes from "prop-types";
import classnames from "classnames";
import "./FlexRow.scss";
import { createDataAttributes } from "../../utilities";

export const FlexRow = ({
  children,
  className,
  wrap,
  align,
  dataAttrib,
  ...rest
}) => {
  const classes = classnames("uikit__flex-row", className, {
    wrap,
    "uikit__flex-row__align-left": align === "left",
    "uikit__flex-row__align-center": align === "center",
    "uikit__flex-row__align-justify": align === "justify",
    "uikit__flex-row__align-right": align === "right"
  });

  return (
    <div className={classes} {...createDataAttributes(dataAttrib)} {...rest}>
      {children}
    </div>
  );
};

FlexRow.propTypes = {
  children: propTypes.any,
  wrap: propTypes.bool,
  className: propTypes.string,
  align: propTypes.string,
  dataAttrib: propTypes.arrayOf(Object)
};

FlexRow.defaultProps = {
  wrap: false
};

export default FlexRow;
